import { defineComponent as _defineComponent } from 'vue'
import WalletBalance from './WalletBalance.vue';
import { FormFieldErrors } from 'ah-common-lib/src/form/components';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { useWalletState } from '..';
import { computed, watch } from 'vue';
import { useOnBehalfOf } from 'ah-common-lib/src/onBehalfOf/useInjectedOBO';
import { BaseFormModel, FieldModel, FormValidation } from 'ah-common-lib/src/form/interfaces';
import { getFieldErrorList } from 'ah-common-lib/src/form/helpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'FieldWalletInfoOrErrors',
  props: {
    model: null,
    field: null,
    walletCurrency: null,
    amountToWithdraw: { default: 0 },
    loading: { type: [Boolean, String], default: false },
    forceLoading: { type: Boolean, default: false },
    hideOverdraft: { type: [Boolean, String], default: false },
    showAvailable: { type: [Boolean, String], default: false },
    overdraftMessage: { default: 'Insufficient funds to settle this trade.' },
    showOverdraftAsWarning: { type: [Boolean, String], default: true },
    errorBeforeAmount: { type: [Boolean, String], default: false },
    clientId: null
  },
  setup(__props: any) {

const props = __props as { model: FieldModel | BaseFormModel, field: FormValidation<any> | null, walletCurrency: string, amountToWithdraw: number | string, loading: boolean | string, forceLoading: boolean, hideOverdraft: boolean | string, showAvailable: boolean | string, overdraftMessage: string, showOverdraftAsWarning: boolean | string, errorBeforeAmount: boolean | string, clientId?: string };



const requestManager = useRequestManager();

const walletState = useWalletState();

const onBehalfOfClient = useOnBehalfOf();

const isLoading = computed(() => loadingWallet.value || props.loading);

const wallet = computed(() => {
  return walletState.store.useWalletsStore().getWallet(props.walletCurrency, {
    isPartner: isPartnerUser.value,
    id: ownerId.value,
  });
});

const isErrorOnTop = computed(() => props.errorBeforeAmount !== false);

const displayOverdraftAsError = computed(() => props.showOverdraftAsWarning === false);

const isOverdraft = computed(() => wallet.value && withdrawAmount.value && withdrawAmount.value > wallet.value.balance);

const shouldShowOverdraft = computed(() => isOverdraft.value && props.hideOverdraft === false);

const withdrawAmount = computed(() =>
  typeof props.amountToWithdraw === 'string' ? parseFloat(props.amountToWithdraw) : props.amountToWithdraw
);

const loadingWallet = computed(() => requestManager.manager.requestStates.loadWallet === 'pending');

const hasErrors = computed(() => props.field && getFieldErrorList(props.field, props.model as FieldModel).length > 0);

const isPartnerUser = computed(() => !onBehalfOfClient.value && !walletState.store.useAuthStore().isClientUser);

const ownerId = computed(() => {
  if (onBehalfOfClient.value) {
    return onBehalfOfClient.value.id;
  } else if (props.clientId) {
    return props.clientId;
  }
  return (
    walletState.store.useAuthStore().loggedInIdentity?.client?.id ||
    walletState.store.useAuthStore().loggedInIdentity?.partner?.id
  );
});

watch(
  () => props.walletCurrency,
  () => {
    if (props.walletCurrency) {
      walletState.store.useWalletsStore().loadCurrencyWallet({
        currency: props.walletCurrency,
        force: props.forceLoading,
        owner: { isPartner: isPartnerUser.value, id: ownerId.value },
      });
    }
  },
  { immediate: true }
);

return { __sfc: true,props, requestManager, walletState, onBehalfOfClient, isLoading, wallet, isErrorOnTop, displayOverdraftAsError, isOverdraft, shouldShowOverdraft, withdrawAmount, loadingWallet, hasErrors, isPartnerUser, ownerId, WalletBalance, FormFieldErrors }
}

})